import { OrderDataFieldConfigurations, OrderDataFields } from "../../interfaces/OrderData/OrderData";

export const orderDataFieldConfigurations: OrderDataFieldConfigurations = {
    [OrderDataFields.AGB]: {
        required: true,
    },
    [OrderDataFields.PLUSOPTION]: {
        required: false,
    },
    [OrderDataFields.TRACKINGCONSENT]: {
        required: false,
    },
};